const replaceSpeakerLabels = (data, oldLabels, newLabels) => {
  const newData = JSON.parse(JSON.stringify(data)); // Deep copy to avoid mutation
  const replaceLabels = obj => {
    Object.keys(obj).forEach(key => {
      if (typeof obj[key] === "object") replaceLabels(obj[key]);
      else {
        oldLabels.forEach((oldLabel, index) => {
          if (obj[key] === oldLabel) obj[key] = newLabels[index];
        });
      }
    });
  };
  replaceLabels(newData);
  return newData;
};

const conversation = data => {
  const newData = replaceSpeakerLabels(data?.Conversation?.TranscriptSegments, ["CLINICIAN_0", "CLINICIAN_1"], ["Person_1", "Person_2"]);
  const content = newData
    ?.map(segment => {
      const speaker = segment.ParticipantDetails.ParticipantRole; // Adjust this path based on your data structure
      const content = segment.Content; // Adjust this path based on your data structure
      return `<h3>${speaker}: <span>${content}</span> </h3> </br>`;
    })
    .join("\n");

  return content;
};

const summary = data => {
  const formattedSummary = data
    ?.map(section => {
      const sectionName = section.SectionName.replace(/_/g, " ")
      const summaries = section.Summary.map(item => {
        return `${item.SummarizedSegment.replace(/\n/g, "")}`;
      }).join("</br>");
      return `<h3><strong>${sectionName}</strong></h3><ul>${summaries}</ul>`;
    })
    .join("</br>");
  return formattedSummary;
};

export const TranscribeConvertService = {
  conversation,
  summary
};
